import React from "react";
import { dialogContentClasses } from "@mui/material";
import HyroStepperDialog from "@hyro-components/hyro-stepper-dialog/HyroStepperDialog";
import useDeployWizard from "./DeployWizard.hook";

const DeployWizard = ({ mode, initialData, onSubmit, onClose }) => {
  const {
    steps,
    activeStep,
    setActiveStep,
    handleDeploy,
    exitWizard
  } = useDeployWizard({ mode, initialData, onSubmit, onClose });

  return (
    <HyroStepperDialog
      open
      fullScreen
      showLogo
      steps={steps}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      handleDone={handleDeploy}
      handleCancel={exitWizard}
      sx={{ [`& .${dialogContentClasses.root}`]: { padding: 0 } }}
    />
  );
};

export default DeployWizard;
